var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_38)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M62.1999 44L73.2399 24H24.6399L34.1199 44H62.1999Z",
    fill: "#2B3E5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2 52C65.2 52 67.84 50.36 69.2 47.88L83.52 21.92C85 19.28 83.08 16 80.04 16H20.84L17.08 8H4V16H12L26.4 46.36L21 56.12C18.08 61.48 21.92 68 28 68H76V60H28L32.4 52H62.2ZM24.64 24H73.24L62.2 44H34.12L24.64 24ZM28 72C23.6 72 20.04 75.6 20.04 80C20.04 84.4 23.6 88 28 88C32.4 88 36 84.4 36 80C36 75.6 32.4 72 28 72ZM68 72C63.6 72 60.04 75.6 60.04 80C60.04 84.4 63.6 88 68 88C72.4 88 76 84.4 76 80C76 75.6 72.4 72 68 72Z",
    fill: "#2B3E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 17,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_616_38)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79 7C73.4875 7 69 11.4875 69 17C69 22.5125 73.4875 27 79 27C84.5125 27 89 22.5125 89 17C89 11.4875 84.5125 7 79 7ZM76.5 23.25L71.5 18.25L73.2625 16.4875L76.5 19.7125L84.7375 11.475L86.5 13.25L76.5 23.25Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 4.5C72.1 4.5 66.5 10.1 66.5 17C66.5 23.9 72.1 29.5 79 29.5C85.9 29.5 91.5 23.9 91.5 17C91.5 10.1 85.9 4.5 79 4.5ZM79 27C73.4875 27 69 22.5125 69 17C69 11.4875 73.4875 7 79 7C84.5125 7 89 11.4875 89 17C89 22.5125 84.5125 27 79 27ZM84.7375 11.475L76.5 19.7125L73.2625 16.4875L71.5 18.25L76.5 23.25L86.5 13.25L84.7375 11.475Z",
    fill: "#FFA000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_616_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(64 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.eed7c04c56f7d0dfac1b7c5da82f7145.svg";
export { ForwardRef as ReactComponent };